// Maps messenger routes to the shared Access-profile permission keys (the same
// keys TeamLio defines in its panelCatalog). Messenger-native pages (Chat,
// Calls, Calendar) are never gated.

interface PanelPath {
  key: string;
  path: string;
}

// Order matters: longer paths first so "/tasks/reports" wins over "/tasks".
const PANEL_PATHS: PanelPath[] = [
  { key: 'dbms', path: '/dbms' },
  { key: 'activity-comparison', path: '/employee/workflow/comparison' },
  { key: 'work-schedule', path: '/employee/workflow/schedule' },
  { key: 'activity-reports', path: '/employee/workflow/activity' },
  { key: 'downloads', path: '/downloads' },
  // Gates the Leo / "Lio" assistant page. Adding it here flips /leo from a
  // native always-shown page to one governed by the shared "leo" Access panel
  // (backend-enforced in hrms on /leo/*). Users whose profile omits it get the
  // nav hidden and a redirect; no-profile users stay permissive as with any panel.
  { key: 'leo', path: '/leo' },
  { key: 'task-reports', path: '/tasks/reports' },
  { key: 'attendance', path: '/employee/attendance' },
  { key: 'leaves', path: '/employee/leaves' },
  { key: 'expenses', path: '/employee/expenses' },
  { key: 'expenses', path: '/expenses' },
  { key: 'todo', path: '/todo' },
  { key: 'projects', path: '/projects' },
  { key: 'tasks', path: '/tasks' },
  { key: 'clients', path: '/clients' },
  { key: 'vendors', path: '/vendors' },
];

// Returns the permission key for a path, or null for non-gated (native) pages.
export function panelKeyForPath(pathname: string): string | null {
  for (const p of PANEL_PATHS) {
    if (pathname === p.path || pathname.startsWith(p.path + '/')) return p.key;
  }
  return null;
}
